<main class="payee-case-mokk-page">
  <div class="toolbar flex wrap">
    <div class="filter-chips-container flex wrap">
      <app-payee-case-mokk-id-filter [control]="mokkIdFilterControl"></app-payee-case-mokk-id-filter>
      <app-payee-case-mokk-label-filter [control]="mokkLabelFilterControl"></app-payee-case-mokk-label-filter>
      <app-payee-case-mokk-payee-case-reference-id-filter
        [control]="payeeCaseReferenceIdFilterControl"
      ></app-payee-case-mokk-payee-case-reference-id-filter>
      <app-payee-case-mokk-debtor-name-filter [control]="debtorNameFilterControl"></app-payee-case-mokk-debtor-name-filter>
      <app-payee-case-mokk-with-media-filter [control]="includeWithoutMediaControl"></app-payee-case-mokk-with-media-filter>
      <app-payee-case-mokk-without-transition-log-filter
        [control]="includeWithTransitionsControl"
      ></app-payee-case-mokk-without-transition-log-filter>
      <app-payee-case-mokk-show-hidden-filter [control]="showHiddenControl"></app-payee-case-mokk-show-hidden-filter>
    </div>

    @if (!isProduction) {
      <button
        payee-button
        color="white"
        type="button"
        class="debug-upload-button"
        (click)="openUploadDebugMokkDialog()"
      >
        {{ "PAYEE_CASE_MOKK_TABLE.DEBUG_UPLOAD.BUTTON" | translate }}
      </button>
    }

    @if (loading()) {
      <mat-spinner
        diameter="28"
        class="loading-spinner"
      ></mat-spinner>
    }
  </div>

  <table
    mat-table
    class="mokk-table mat-elevation-z1"
    multiTemplateDataRows
    [dataSource]="dataSource"
  >
    <ng-container matColumnDef="event_at">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        {{ "PAYEE_CASE_MOKK_TABLE.HEADERS.EVENT_AT" | translate }}
      </th>
      <td
        *matCellDef="let row"
        mat-cell
      >
        {{ (row.event_at | date: "yyyy.MM.dd. HH:mm") || "-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="mokk_id">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        {{ "PAYEE_CASE_MOKK_TABLE.HEADERS.MOKK_ID" | translate }}
      </th>
      <td
        *matCellDef="let row"
        mat-cell
      >
        <div
          class="case-id-box"
          role="button"
          tabindex="0"
          (click)="copyMokkIdToClipboard(row.mokk_id, $event)"
          (keydown.enter)="copyMokkIdToClipboard(row.mokk_id, $event)"
          (keydown.space)="copyMokkIdToClipboard(row.mokk_id, $event); $event.preventDefault()"
        >
          <span class="case-id-text">{{ row.mokk_id }}</span>
          <payee-icon
            name="copy-blue"
            width="14px"
            height="14px"
            class="case-id-icon"
          ></payee-icon>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="mokk_label">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        {{ "PAYEE_CASE_MOKK_TABLE.HEADERS.MOKK_LABEL" | translate }}
      </th>
      <td
        *matCellDef="let row"
        mat-cell
      >
        {{ row.mokk_label || "-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="payee_case_reference_id">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        {{ "CASES_TABLE.HEADERS.CASE_ID" | translate }}
      </th>
      <td
        *matCellDef="let row"
        mat-cell
      >
        <div
          class="case-id-box"
          role="button"
          tabindex="0"
          (click)="copyCaseIdToClipboard(row.payee_case.payee_case_reference_id, $event)"
          (keydown.enter)="copyCaseIdToClipboard(row.payee_case.payee_case_reference_id, $event)"
          (keydown.space)="copyCaseIdToClipboard(row.payee_case.payee_case_reference_id, $event); $event.preventDefault()"
        >
          <span class="case-id-text">{{ row.payee_case.payee_case_reference_id }}</span>
          <payee-icon
            name="copy-blue"
            width="14px"
            height="14px"
            class="case-id-icon"
          ></payee-icon>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="debtor">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        {{ "CASES_TABLE.HEADERS.PARTIES" | translate }}
      </th>
      <td
        *matCellDef="let row"
        mat-cell
      >
        <strong>{{ row.payee_case.parties.debtor_name || "-" }}</strong>
      </td>
    </ng-container>

    <ng-container matColumnDef="state">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        {{ "CASES_TABLE.HEADERS.STATE" | translate }}
      </th>
      <td
        *matCellDef="let row"
        mat-cell
      >
        <div class="flex column status-box">
          <div
            class="state-box flex vcenter"
            [style.color]="row.payee_case.state.state_label_text_color"
            [style.background-color]="row.payee_case.state.state_label_background_color"
          >
            <div
              class="state-marker"
              [style.background-color]="row.payee_case.state.state_label_text_color"
            ></div>
            <span class="state">{{ row.payee_case.state.state_label }}</span>
          </div>
          <span class="stage">{{ row.payee_case.state.stage_label }}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="last_transition">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        {{ "PAYEE_CASE_MOKK_TABLE.HEADERS.LAST_TRANSITION" | translate }}
      </th>
      <td
        *matCellDef="let row"
        mat-cell
      >
        @if (lastTransitionLog(row); as log) {
          <div class="last-transition-cell flex column">
            <span>{{ log.label }}</span>
            @if (log.created_at) {
              <span class="muted last-transition-meta">
                {{ log.created_at | date: "yyyy.MM.dd. HH:mm" }}
              </span>
            }
          </div>
        } @else {
          —
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="first_file">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        {{ "PAYEE_CASE_MOKK_TABLE.HEADERS.FIRST_FILE" | translate }}
      </th>
      <td
        *matCellDef="let row"
        mat-cell
      >
        @if (row.mokk_media?.length) {
          <a
            target="_blank"
            rel="noopener"
            [href]="row.mokk_media[0].url"
            (click)="$event.stopPropagation()"
          >
            {{ row.mokk_media[0].file_name }}
          </a>
        }
        @if (!row.mokk_media?.length) {
          <span>—</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        *matHeaderCellDef
        mat-header-cell
      ></th>
      <td
        *matCellDef="let row"
        mat-cell
        (click)="$event.stopPropagation()"
      >
        <div class="actions-cell-inner flex vcenter">
          <button
            mat-icon-button
            type="button"
            class="hide-mokk-button"
            [matTooltip]="(row.hidden_at ? 'PAYEE_CASE_MOKK_TABLE.ACTIONS.UNHIDE' : 'PAYEE_CASE_MOKK_TABLE.ACTIONS.HIDE') | translate"
            (click)="setMokkHidden(row, !row.hidden_at, $event)"
          >
            <mat-icon>{{ row.hidden_at ? "visibility" : "visibility_off" }}</mat-icon>
          </button>
          @if (hasMokkEvent(row)) {
            <button
              payee-icon-button
              class="actions-menu-button"
              color="white"
            >
              <payee-icon name="checkmark-darker-green-circle"></payee-icon>
            </button>
          } @else {
            <payee-cases-actions-menu
              [element]="row.payee_case"
              [allowEdit]="false"
              [allowDelete]="false"
              [additionalActions]="additionalActions"
              [transitionMedia]="getTransitionMedia(row)"
              [transitionExtraParams]="{ mokk_id: row.id }"
              (menuOpened)="onActionsMenuOpen()"
              (menuClosed)="onActionsMenuClosed()"
            ></payee-cases-actions-menu>
          }
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="detailsToggle">
      <th
        *matHeaderCellDef
        mat-header-cell
      ></th>
      <td
        *matCellDef="let row"
        mat-cell
      >
        <payee-icon name="arrow-down-grey-no-shaft"></payee-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td
        *matCellDef="let row"
        mat-cell
        class="expanded-detail-cell"
        [attr.colspan]="displayedColumns.length"
      >
        <div class="expanded-detail-inner alt-theme">
          @if (row === expandedElement) {
            <div
              class="expanded-detail-content"
              animate.enter="expand-enter"
              animate.leave="expand-leave"
            >
              <div class="expanded-detail-content-inner flex column">
                <div class="expanded-content-container flex grow1">
                  <div class="section-container flex column grow1">
                    <h3 class="section-title">
                      {{ "CASES_TABLE.CASE_DETAILS.EVENTS_LABEL" | translate }}
                    </h3>
                    <app-case-events
                      [caseItem]="row.payee_case"
                      [mokk]="row"
                    ></app-case-events>
                  </div>
                  @if ((row.payee_case.displayed_claim | keyvalue)?.length) {
                    <div class="section-container flex column grow1">
                      <h3 class="section-title">
                        {{ "CASES_TABLE.CASE_DETAILS.DETAILS_LABEL" | translate }}
                      </h3>
                      <app-case-details [caseId]="row.payee_case.id"></app-case-details>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </td>
    </ng-container>

    <tr
      *matHeaderRowDef="displayedColumns"
      mat-header-row
      class="mokk-header"
    ></tr>
    <tr
      *matRowDef="let row; columns: displayedColumns"
      mat-row
      class="element-row"
      [class.expanded-row]="expandedElement === row"
      [class.hidden-mokk-row]="row.hidden_at"
      (click)="updateExpandedElement(row)"
    ></tr>
    <tr
      *matRowDef="let row; columns: ['expandedDetail']"
      mat-row
      class="detail-row"
    ></tr>
  </table>

  <mat-paginator
    showFirstLastButtons
    [length]="total"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="[10, 25, 100]"
    (page)="onPage($event)"
  ></mat-paginator>
</main>
